
import React, { useState, useEffect } from "react";
import { useMsal } from '@azure/msal-react';
import Sidebar from "./components/Sidebar";
import MainContent from "./components/MainContent";
import Header from "./components/Header";
import LoginPage from "./LoginPage";
import Footer from "./components/Footer";
import "./App.css";

const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
console.log("CLIENT_ID from env:", CLIENT_ID);

function App() {
  const [activeDashboard, setActiveDashboard] = useState("Firm and Opportunity");
  const { instance } = useMsal();
  const [user, setUser] = useState(null);
  const [clearChatTrigger, setClearChatTrigger] = useState(0);

  useEffect(() => {
    const accounts = instance.getAllAccounts();
    if (accounts && accounts.length > 0) {
      const account = accounts[0];
      setUser({
        id: account.localAccountId,
        username: account.username,
        organizationId: account.tenantId,
        email: account.username,
        role: 'user',
        name: account.name,
      });
    }
  }, [instance]);
  

 const handleLogin = async () => {
    try {
      const loginResponse = await instance.loginPopup();
      // Acquire access token for API scope
      const tokenResponse = await instance.acquireTokenSilent({
        account: loginResponse.account,
        scopes: [`${CLIENT_ID}/.default`]
      });
      const accessToken = tokenResponse.accessToken;
      // Store in sessionStorage for later use
      sessionStorage.setItem("accessToken", accessToken);
      const userData = {
        id: loginResponse.account.localAccountId,
        username: loginResponse.account.username,
        organizationId: loginResponse.account.tenantId,
        email: loginResponse.account.username,
        role: 'user',
        name: loginResponse.account.name,
        accessToken
      };
      setUser(userData);
    } catch (error) {
      alert('Login failed: ' + error.message);
    }
  };

  const handleLogout = async () => {
    // Clear recent queries and chat history for all dashboards for this user
    if (user) {
      ["Firm and Opportunity", "Order Book"].forEach(dashboard => {
        localStorage.removeItem(`recentQueries_${user.id}_${dashboard}`);
        localStorage.removeItem(`chatHistory_${user.id}_${dashboard}`);
      });
    }
    await instance.logoutPopup();
    setUser(null);
  };

  const handleClearChat = (dashboard) => {
    if (user) {
      localStorage.removeItem(`chatHistory_${user.id}_${dashboard}`);
      localStorage.removeItem(`recentQueries_${user.id}_${activeDashboard}`);
      setClearChatTrigger(prev => prev + 1);
    }
  };

  
  // ChatBox query population
  const [selectedQuery, setSelectedQuery] = useState("");
  const handleQuerySelect = (query) => setSelectedQuery(query);

  return user ? (
    <div className="app">
      <Header onLogout={handleLogout} onClearChat={() => handleClearChat(activeDashboard)} userName={user.name || user.username} />
      <div className="content-area">
        <Sidebar
          activeDashboard={activeDashboard}
          setActiveDashboard={setActiveDashboard}
          onQuerySelect={handleQuerySelect}
          clearChatTrigger={clearChatTrigger}
          user={user}
        />
        <MainContent activeDashboard={activeDashboard} selectedQuery={selectedQuery} user={user} clearChatTrigger={clearChatTrigger}/>
      </div>
      <Footer />
    </div>
  ) : (
    <LoginPage onLogin={handleLogin} />
  );
}

export default App;
